import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from './routes';
import { useAppSelector } from './store';
import RouteWithPermit from 'core/RouteWithPermit';
import { useUser } from 'pages/hooks';
import { Permit } from 'api/resources/models/AutoGenerated';

interface Props {
  anyOfPermits?: Permit[];
}
 export const PrivateRoute = ({ anyOfPermits }: Props) => {
  const authUser = useAppSelector((state) => state.auth.user);
  const { user } = useUser();
  if (!authUser) return <Navigate to={ROUTES.login} />;
  if (anyOfPermits) return <RouteWithPermit anyOfPermits={anyOfPermits} />;
  if (user) return <Outlet />;
  return <></>;
};